<div class="container-fluid relatorio-risco-gaiola">
  <h3>Relatório de Risco Gaiola</h3>
  <mat-card>
    <mat-card-header class="header-padrao">
      <mat-card-title>
        <form class="d-flex align-items-center filtros-header" [formGroup]="filterForm">
          <mat-form-field>
            <mat-label>Data Inicial:</mat-label>
            <input
              matInput
              autocomplete="off"
              maskDate
              [matDatepicker]="dataInicio"
              formControlName="dataInicio">
            <mat-datepicker-toggle matSuffix [for]="dataInicio"></mat-datepicker-toggle>
            <mat-datepicker #dataInicio></mat-datepicker>
          </mat-form-field>

          <mat-form-field>
            <mat-label>Data Final:</mat-label>
            <input
              matInput
              autocomplete="off"
              maskDate
              [matDatepicker]="dataFim"
              formControlName="dataFim">
            <mat-datepicker-toggle matSuffix [for]="dataFim"></mat-datepicker-toggle>
            <mat-datepicker #dataFim></mat-datepicker>
          </mat-form-field>

          <mat-form-field>
            <mat-label>IATA:</mat-label>
            <mat-select
              formControlName="iata"
              disableOptionCentering="true"
              multiple
              placeholder="Iata">
                <mat-option><ngx-mat-select-search [formControl]="iataMultiFilter" placeholderLabel="Buscar..."
                noEntriesFoundLabel="Nenhum resultado encontrado..."></ngx-mat-select-search></mat-option>
              <mat-option selected value="">Todas</mat-option>
              <mat-option
                *ngFor="let iata of filteredIatas | async"
                [value]="iata?.id" [matTooltip]="iata?.name + '-' + iata?.iataNomeFantasia">
                  {{ iata?.name }} - {{ iata?.iataNomeFantasia }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field>
            <mat-label>Número Manifesto:</mat-label>
            <input
              matInput
              somenteNumeros
              autocomplete="off"
              formControlName="manifesto">
          </mat-form-field>
          <mat-form-field>
            <mat-label>NRT:</mat-label>
            <input
              matInput
              somenteNumeros
              autocomplete="off"
              formControlName="nrt">
          </mat-form-field>
          <mat-form-field>
            <mat-label>Gaiola:</mat-label>
            <input
              matInput
              autocomplete="off"
              formControlName="gaiola">
          </mat-form-field>
          <mat-form-field>
            <mat-label>Recepcionado:</mat-label>
            <mat-select formControlName="recepcionado">
              <mat-option *ngFor="let recepcionado of selectRecepcionado"
                [value]="recepcionado.status">
                  {{recepcionado.descricao}}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <button mat-icon-button (click)="clearFields()" matTooltip="Limpar Campos">
            <i class="fas fa-eraser eraser-button"></i>
          </button>
          <button
            mat-icon-button
            class="pesquisar"
            (click)="paging.index = 0; listarRelatoriosRiscoGaiola()"
            [disabled]="filterForm.invalid">
              <i class="fas fa-search search-button cursor-pointer-icon" matTooltip="Pesquisar"></i>
          </button>
        </form>
      </mat-card-title>
    </mat-card-header>
    <mat-progress-bar color="primary" mode="indeterminate" [hidden]="!isLoading"></mat-progress-bar>
    <mat-card-content class="no-padding">
      <div [hidden]="isLoading || (!listaRelatorioRiscoGaiola || listaRelatorioRiscoGaiola?.length === 0)">
        <div>
          <table mat-table [dataSource]="listaRelatorioRiscoGaiola" class="table-sm">

            <ng-container matColumnDef="manifesto">
              <th mat-header-cell *matHeaderCellDef>Manifesto</th>
              <td mat-cell *matCellDef="let element">{{ element.manifesto }}</td>
            </ng-container>

            <ng-container matColumnDef="filialOrigem">
              <th mat-header-cell *matHeaderCellDef>Filial Origem</th>
              <td mat-cell *matCellDef="let element"> {{ element.filialOrigem }} </td>
            </ng-container>

            <ng-container matColumnDef="filialDestino">
              <th mat-header-cell *matHeaderCellDef>Filial Destino</th>
              <td mat-cell *matCellDef="let element"> {{ element.filialDestino }}</td>
            </ng-container>

            <ng-container matColumnDef="iata">
              <th mat-header-cell *matHeaderCellDef>Iata</th>
              <td mat-cell *matCellDef="let element">{{ element.iata }}</td>
            </ng-container>

            <ng-container matColumnDef="qtdVolume">
              <th mat-header-cell *matHeaderCellDef>Volume</th>
              <td mat-cell *matCellDef="let element"> {{ element.qtdVolume }}</td>
            </ng-container>

            <ng-container matColumnDef="usuarioManifestador">
              <th mat-header-cell *matHeaderCellDef>Usuário Manifestador</th>
              <td mat-cell *matCellDef="let element"> {{ element.usuarioManifestador }}</td>
            </ng-container>

            <ng-container matColumnDef="dataInclusao">
              <th mat-header-cell *matHeaderCellDef>Data Inclusão</th>
              <td mat-cell *matCellDef="let element"> {{ element.dataInclusao | date: 'dd/MM/yyyy - HH:mm:ss' }}</td>
            </ng-container>

            <ng-container matColumnDef="usuarioRecepcao">
              <th mat-header-cell *matHeaderCellDef>Usuário Recepção</th>
              <td mat-cell *matCellDef="let element"> {{ element.usuarioRecepcao }}</td>
            </ng-container>

            <ng-container matColumnDef="dataRecep">
              <th mat-header-cell *matHeaderCellDef>Data Recepção</th>
              <td mat-cell *matCellDef="let element"> {{ element.dataRecep | date: 'dd/MM/yyyy - HH:mm:ss' }}</td>
            </ng-container>

            <ng-container matColumnDef="codigoGaiola">
              <th mat-header-cell *matHeaderCellDef>Código Gaiola</th>
              <td mat-cell *matCellDef="let element"> {{ element.codigoGaiola }}</td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

          </table>
        </div>

        <app-paginacao
          [pageIndex]="paging?.index"
          [pageSize]="paging?.size"
          [length]="paging?.length"
          (page)="onPageChange($event)"
          [pageSizeOptions]="[10, 20, 50]"></app-paginacao>

        <div class="d-flex justify-content-end align-items-center pr-2 pt-2">
          <button mat-flat-button type="button" color="success" (click)="downloadExcel()"
            [disabled]="isLoadingDownload">
            <span *ngIf="isLoadingDownload" class="d-flex align-items-center">
              <mat-spinner diameter="20" color="dark"></mat-spinner>
              &nbsp; Baixando
            </span>
            <span *ngIf="!isLoadingDownload">
              <i class="fas fa-file-excel"></i> Download Excel
            </span>
          </button>
        </div>
      </div>
      <div *ngIf="!isLoading && (listaRelatorioRiscoGaiola && listaRelatorioRiscoGaiola?.length === 0)"
        class="d-flex justify-content-center align-items-center" style="height: 100px;">
        Nenhum registro para o período!
      </div>
    </mat-card-content>
  </mat-card>
</div>
